import { render, staticRenderFns } from "./toolbar_more_dropdown.vue?vue&type=template&id=13620cbe&vue3"
import script from "./toolbar_more_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./toolbar_more_dropdown.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports